module.exports = __webpack_public_path__ + "static/media/kidsartkids_02_B.ad868401.png";